<template>
  <nav
    class="topbar-secondary flex h-12 min-w-0 items-center px-4"
    :data-test="data_test"
    :aria-label="aria_label"
  >
    <slot />
    <div class="ml-auto flex shrink-0 items-center gap-2">
      <slot name="right">
        <NavbarHorizontalActions />
      </slot>
    </div>
  </nav>
</template>

<script setup>
import NavbarHorizontalActions from '@/app/shared_components/navbar/NavbarHorizontalActions.vue';

defineProps({
  data_test: { type: String, default: null },
  aria_label: { type: String, default: null },
});
</script>

<style scoped>
/* Bottom line as inset shadow so active tab borders sit flush on the same line */
.topbar-secondary {
  box-shadow: inset 0 -1px 0 var(--color-neutral-200);
}
</style>
